/* unplugin-vue-components disabled */import { render } from "./suggestions.vue?vue&type=template&id=15b648a8&scoped=true"
import script from "./suggestions.vue?vue&type=script&lang=js"
export * from "./suggestions.vue?vue&type=script&lang=js"

import "./suggestions.vue?vue&type=style&index=0&id=15b648a8&lang=stylus"
import "./suggestions.vue?vue&type=style&index=1&id=15b648a8&scoped=true&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b648a8"],['__file',"src/components/content-editable/suggestions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15b648a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15b648a8', __exports__)) {
    api.reload('15b648a8', __exports__)
  }
  
  module.hot.accept("./suggestions.vue?vue&type=template&id=15b648a8&scoped=true", () => {
    api.rerender('15b648a8', render)
  })

}


export default __exports__